export const changeModisNDVILayerReducer = (state = false, action) => {
  switch (action.type) {
    case "CHANGE_MODIS_NDVI_Layer":
      return action.payload.modisNdviLayer;
    default:
      return state;
  }
};
